import thunk from './middleware/thunk';

const middleware = [
    thunk
];
export default middleware;
